import React from "react";
import { styled } from "styled-components";
import Menubar from "./Menubar";
import MENUICON from "../assets/images/menu.svg";

function MobileMenu() {
  const [menuShow, setMenuShow] = React.useState(false);
  const onMenuToggle = () => {
    setMenuShow(!menuShow);
  };
  return (
    <Wrapper>
      <Button onClick={onMenuToggle}>
        <img src={MENUICON} alt="" />
      </Button>
      {menuShow && <DropBox>
        <Menubar />
      </DropBox>}
    </Wrapper>
  );
}
export default MobileMenu;

const Wrapper = styled.section`
    position: relative;
`;
const Button = styled.button`
    cursor: pointer;
    border: none;
    background: none;
`;
const DropBox = styled.section`
    position: absolute;
    border: 1px solid #ccc;
    top: 20px;
    right: 0;
    width: 150px;
    background: #fff;
    ul{
        display: block;
        height: auto;
    }
    li {        
        line-height: normal;
        a {
            padding: 10px 0 10px 10px;
        }
    }
`;
